import React, { useState } from "react";
import HomeServices from "../../Services/HomeServices";
// import { toast } from "react-toastify";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const AddStaff = () => {
  const [staffData, setStaffData] = useState({
    name: "",
    email: "",
    password: "",
    phoneNo: "",
    address: "",
  });
  const [addStuffLoading, setAddStuffLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setStaffData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !staffData?.name ||
      !staffData?.email ||
      !staffData?.password ||
      !staffData?.phoneNo ||
      !staffData?.address
    )
      return toast.error("Service Name should not be empty");

    try {
      setAddStuffLoading(true);
      const response = await HomeServices.addStaff(staffData);

      if (response.status) {
        toast.success(response.message);
        setAddStuffLoading(false);
        navigate("/managestaff");
      } else {
        toast.error(response.message);
        setAddStuffLoading(false);
      }
    } catch (error) {
      console.error("Error Creating Staff:", error);
      setAddStuffLoading(false);
    }
  };
  return (
    <>
      <div className="d-flex justify-content-end mt-5">
        <div className="form-header">
          <section className="piechartsBox_area">
            {/* <BackPageBtn backLink="/" /> */}

            <form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <div>
                <h1 style={{ color: "#ff9c00" }}>Add Staff</h1>
              </div>

              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    name="name"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    value={staffData?.name}
                    // onChange={(e) => {
                    //   setFormValue({ ...formValue, document: e.target.value });
                    // }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Address</label>
                  <textarea
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    style={{ resize: "none" }}
                    type="text"
                    className="form-control h-75"
                    placeholder="Enter Address"
                    name="address"
                    value={staffData?.address}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Phone Number</label>
                  <input
                    // onChange={(e) => {
                    //   handleChange(e);
                    // }}
                    type="text"
                    className="form-control"
                    placeholder="Enter Phone Number"
                    name="phoneNo"
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setStaffData((prev) => ({
                          ...prev,
                          phoneNo: Number(e.target.value),
                        }));
                      }
                    }}
                    value={staffData?.phoneNo}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Email</label>
                  <input
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    type="text"
                    className="form-control"
                    placeholder="Enter Email"
                    name="email"
                    value={staffData?.email}
                    // onChange={(e) => {
                    //   setFormValue({ ...formValue, document: e.target.value });
                    // }}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Password</label>
                  <input
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    type="text"
                    className="form-control"
                    placeholder="Enter Password"
                    name="password"
                    value={staffData?.password}
                    // onChange={(e) => {
                    //   setFormValue({ ...formValue, document: e.target.value });
                    // }}
                  />
                </div>
              </div>

              {/* <div className="row mt-5">
                <div className="col-md-12">
                  <label htmlFor="formGroupExampleInput">Description</label>
                  <textarea
                    className="form-control"
                    rows={6}
                    name="description"
                    value={formValue?.description}
                    onChange={(e) => { setFormValue({ ...formValue, description: e.target.value }) }}
                  ></textarea>
                </div>
              </div> */}
              <div class="col-12 ">
                <button
                  disabled={addStuffLoading}
                  type="submit"
                  //   onClick={(e) => handleSubmit(e)}
                  class="btn btn-primaryb mt-5 mb-4 addBlogBn"
                  style={{
                    background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                    color: "#fff",
                  }}
                >
                  {/* Add */}
                  {addStuffLoading ? "Adding..." : "Add"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddStaff;
